
.TimeSlotGuide {
    display: block;
    container: week-time-slot-header / inline-size;
    height: var(--Week__slotHeight);
    font-size: 11px;
    padding: 0 0 0 .3rem;

    &:nth-child(2n-1) {
        border-top: solid 1px var(--soniq-t--global--border--color--grid--default);
    }

}

.TimeSlotGuide__time {
    background-color: var(--soniq-t--global--background--color--primary--default);
    display: flex;
    gap: 1px;
    margin: -.5rem 0 0;
    padding: 1px 2px;
    width: max-content;
    border-radius: 2px;
}

.TimeSlotGuide__hour {
}

.TimeSlotGuide__ampm {
    text-transform: lowercase;
    /*display: none;*/

    @container (min-width: 50px) {
        display: block;
    }
}
